import React from 'react';

function MeetingTypeSkeleton() {
  return (
    <div className="flex flex-col justify-between p-5 w-full border animate-pulse">
      <div className="flex pb-2 w-full">
        <div className="w-6 h-6 bg-gray-200 rounded" />
        <div className="ml-2 w-40 h-6 bg-gray-200 rounded" />
      </div>
      <div className="px-5 py-8 space-y-2">
        <div className="w-full h-4 bg-gray-200 rounded" />
        <div className="w-full h-4 bg-gray-200 rounded" />
      </div>
      <div className="w-48 h-8 bg-gray-200" />
    </div>
  );
}

export default function Skeleton() {
  return (
    <div className="flex space-x-8">
      <div className="w-80">
        <MeetingTypeSkeleton />
      </div>
      <div className="hidden w-80 md:block">
        <MeetingTypeSkeleton />
      </div>
    </div>
  );
}
